import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-bon-liv-negoce',
  templateUrl: './tous-bon-liv-negoce.component.html',
  styleUrls: ['./tous-bon-liv-negoce.component.scss']
})
export class TousBonLivNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
